import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { actions } from "../../../reducers/cadastro/feriados.actions";
import { getFeriados } from "../../../selectors/cadastro/feriados.selectors";
import FeriadoPage from "./FeriadoPage";
import {
  actions as routeActions,
  types as routes,
} from "../../../reducers/rotas.actions";
import { getPayload } from "../../../selectors/routes.selectors";

const FeriadoPageConnected = () => {
  const { loading, data, filter, nomeCliente } = useSelector(getFeriados);
  const cliente = useSelector(getPayload);

  const dispatch = useDispatch();

  const handlePagination = (e, page) => {
    dispatch(
      actions.obterFeriados.request({
        pagina: page,
        nome: filter,
        idCliente: cliente?.id,
      })
    );
  };

  const handleDelete = (e, id) => {
    dispatch(actions.deletarFeriado.request({ id }));
  };

  const handleActivate = (e, id) => {
    dispatch(actions.reativarFeriado.request({ id, situacao: "A" }));
  };

  const handleEdit = (e, id) => {
    dispatch(
      routeActions.redirectTo(routes.EDITAR_FERIADO, {
        id: id,
      })
    );
  };

  const handleAdd = () => {
    dispatch(routeActions.redirectTo(routes.CRIAR_FERIADO));
  };

  const handleGoBack = () => {
    dispatch(routeActions.redirectTo(routes.CADASTRO_CLIENTE));
  };

  return (
    <FeriadoPage
      data={data}
      loading={loading}
      handlePagination={handlePagination}
      handleAdd={handleAdd}
      handleDelete={handleDelete}
      handleEdit={handleEdit}
      handleGoBack={handleGoBack}
      handleActivate={handleActivate}
      filtroAtual={filter}
      nomeCliente={nomeCliente}
      cliente={cliente}
    />
  );
};

export default FeriadoPageConnected;
